import { fetchTemplateInstancesPage } from 'common/services/template'
import { TemplateManagerKey } from 'common/constants/templateManager'
import { BRAND_LIST_PAGE_SIZE } from 'common/constants/brand'
import { Template } from 'common/types/entities/mongo/template'
import { Sort } from 'common/constants'

export interface BrandListState {
  brands: Template[]
  hasMore?: boolean
  pageCount?: number
  page: number
  sort: Sort
}

const initialState: BrandListState = {
  brands: [],
  hasMore: false,
  pageCount: 0,
  page: 0,
  sort: Sort.ABC,
}

const FETCH_BRAND_LIST = 'brand/brandList/FETCH_BRAND_LIST'

export const fetchBrandList = (curState, page, sort) => async (dispatch, getState) => {
  const brandListState = getState().brands[curState]
  const results = await fetchTemplateInstancesPage(TemplateManagerKey.ART_ARTIST_LIST, {
    page,
    sort,
    preview: true,
    pageSize: BRAND_LIST_PAGE_SIZE,
  })
  const fetchedData = results.instances
  const brands = page === 1 ? fetchedData : [...brandListState.brands, ...(fetchedData || [])]
  dispatch({
    curState,
    page,
    brands,
    sort,
    hasMore: results.hasMore,
    type: FETCH_BRAND_LIST,
  })
}

const brandListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_LIST:
      return {
        ...action,
      }
    default:
      return state
  }
}

export default brandListReducer
